import EADialog from 'components/common/EADialog';
import EAIcon from 'components/common/EAIcon';
import useStyles from 'style/js-style/components/common/StoppingConfirmationDialogStyle';

const StoppingConfirmationDialog = ({ isOpen = false, title, description, onValidate = () => { }, onClose = () => { } }) => {
  const { classes } = useStyles();

  return (
    <EADialog isOpen={isOpen} maxWidth="sm" variant='redValid' onValidate={onValidate} onCancel={onClose} onClose={onClose}>
      <div className={classes.dialogStop}>
        <div className={classes.dialogStopContent}>
          <div className={classes.dialogStopIcon}>
            <EAIcon icon="stop_scoring" />
          </div>
          <div className={classes.dialogTitle}>{title}</div>
          <div className={classes.dialogDescription}>{description}</div>
        </div>
      </div>
    </EADialog>
  )
};

export default StoppingConfirmationDialog;